export default {
  data() {
    return {
      successDismissCountDown: 0,
      warningDismissCountDown: 0,
    };
  },
  methods: {
    successCountDownChanged(dismissCountDown) {
      this.successDismissCountDown = dismissCountDown;
    },
    showSuccessAlert() {
      this.successDismissCountDown = 15;
    },
    hideSuccessAlert() {
      this.successDismissCountDown = 0;
    },
    warningCountDownChanged(dismissCountDown) {
      this.warningDismissCountDown = dismissCountDown;
    },
    showWarningAlert() {
      this.warningDismissCountDown = 15;
    },
    hideWarningAlert() {
      this.warningDismissCountDown = 0;
    },
  },
};
